var public_nurseslounge_myDashboard_myProfile = {
    init:function($params){
        libs.globalUrl();
        $(".nav-underline a:eq(0)").addClass('active');
        libs.subrender('/public/myDashboard/myProfile', 'public_nurseslounge_myDashboard_myProfile', 'sub_render', $params, 'POST');
    },
    sub_render:function($params){
        nurseslounge_myDashboard.menu_scroll();
        public_nurseslounge_myDashboard_myProfile.events($params);
        nurseslounge_myDashboard_activity.lounge_follow_request(function($chtml){
            public_nurseslounge_myDashboard_myProfile.lounge_follow_container($chtml);
        });
        nurseslounge_myDashboard_colleagues.recommended_friends(function($chtml){
            public_nurseslounge_myDashboard_myProfile.recommended_friends_container($chtml);
        });
        nurseslounge_myDashboard_myProfile.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
    },
    events:function(){
        var $nav = $(".nav-underline");
        var $navLink = $nav.find('.nav-link');
        $navLink.unbind().click(function(){
            var $that = $(this);
            var $id = $that.data('id');
            $id = libs.snakeToCamel('profile_'+$id);
            public_nurseslounge_lounge_overview.login_popup({id:$id});
        });
        $(".nurseslounge-home-my-profile-left-profile-about-my-career").hide();
        var $imageChange = $("#content #nurseslounge-lounge .image-change");
        $imageChange.unbind().click(function(){
            public_nurseslounge_lounge_overview.login_popup({id:'profileEvent'});
        });
        var $myProfileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left");
        var $editProfile = $myProfileLeft.find('.edit-profile');
        $editProfile.unbind().click(function(){
            public_nurseslounge_lounge_overview.login_popup({id:'profileEvent'});
        });
        var $editAboutMyCareer = $myProfileLeft.find('.edit-aboutMyCareer');
        $editAboutMyCareer.unbind().click(function(){
            public_nurseslounge_lounge_overview.login_popup({id:'profileEvent'});
        });
        var $addExperience = $myProfileLeft.find('.add-experience');
        $addExperience.unbind().click(function(){
            public_nurseslounge_lounge_overview.login_popup({id:'profileEvent'});
        });
        var $editExperience = $myProfileLeft.find('.edit-experience');
        $editExperience.unbind().click(function(){
            public_nurseslounge_lounge_overview.login_popup({id:'profileEvent'});
        });
        var $addEducation = $myProfileLeft.find('.add-education');
        $addEducation.unbind().click(function(){
            public_nurseslounge_lounge_overview.login_popup({id:'profileEvent'});
        });
        var $editEducation = $myProfileLeft.find('.edit-education');
        $editEducation.unbind().click(function(){
            public_nurseslounge_lounge_overview.login_popup({id:'profileEvent'});
        });
        var $editCertification = $myProfileLeft.find('.edit-certification');
        $editCertification.unbind().click(function(){
            public_nurseslounge_lounge_overview.login_popup({id:'profileEvent'});
        });
        var $addCards = $myProfileLeft.find('.add-cards');
        $addCards.unbind().change(function(){
            var $that = $(this);
            $that.val('');
            public_nurseslounge_lounge_overview.login_popup({id:'profileEvent'});
        });
        var $readMore = $myProfileLeft.find('.read-more');
        $readMore.unbind().click(function(){
            public_nurseslounge_lounge_overview.login_popup({id:'profileEvent'});
        });
    },
    //Follow Lounges
    lounge_follow_container:function($chtml){
        libs.checkImageLoad($($chtml).find('img'), function(){
            $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right .follow-lounges").html($chtml).promise().done(function(){
                var $href = $(this).find('a');
                $href.unbind().click(function($e){
                    $e.preventDefault();
                    var $that = $(this);
                    var $key = $that.data('key');
                    //var $publicLink = $that.data('public_link');
                    //window.open($publicLink, '_self');
                    public_nurseslounge_lounge_overview.login_popup({id:'activity',key:$key});
                });
            });
        });
    },
    //Recommended Friends
    recommended_friends_container:function($chtml){
        if($chtml == ''){
            $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right .invite-colleagues").parents('.card:first').remove();
            return false;
        }
        libs.checkImageLoad($($chtml).find('img'), function(){
            $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right .invite-colleagues").html($chtml).promise().done(function(){
                $(this).find(".open-profile").unbind().click(function(){
                    var $userId = $(this).data('id');
                    public_nurseslounge_lounge_overview.login_popup({id:'knowUser',user_id:$userId});
                });
                $(this).find(".send-friend-request").unbind().click(function($e){
                    $e.stopPropagation();
                    var $li = $(this).parents('li:first');
                    var $userId = $li.data('id');
                    public_nurseslounge_lounge_overview.login_popup({id:'knowUser',user_id:$userId});
                });
            });
        });
    },
};
